/* 
Object:         Form
Description:    Logic around submitting a form. Gives feedback to the user in a simple manner. Redirects users back or forward. 
Used in:        Forms, TagHelper (submit button)
*/

import { form } from "./_entry";
import * as appsettings from "./appsettings";
import * as inputs      from "./inputs";
import * as main        from "./main";
import * as navigation  from "./navigation";

const WAIT_DELAY = 3000;

/**
 * submit form with action. Report result back by calling showResult
 * @param {string} formId
 * @param {string} actionUrl
 * @param {boolean} navigateBack
 * @param {string} kendoWindowId
 */
function submitFormWithFile(formId: string, actionUrl: string, navigateBack: boolean, kendoWindowId: string): void {
    const validator = $('#' + formId).kendoValidator().data('kendoValidator');

    if (validator.validate()) {

        // Serialize form data
        const formData = new FormData($('#' + formId)[0] as any);                            // Welke FormData wordt hier aangeroepen ?   $('#' + formId)[0]

        $.ajax({
            url: appsettings.getUrl(actionUrl),
            type: 'POST',
            data: formData,
            /*The processData and contentType options are set to false to prevent jQuery from processing the data or setting the content type, respectively.
             *This is necessary when sending binary data, such as a file. */
            processData: false,
            contentType: false,

            success: function (responseData) {

                inputs.removeDirtyInput(); // remove dirty input

                // redirect
                if (responseData.RedirectTo != undefined) {

                    // succesfull callback 
                    if (responseData.Succesfully) {
                        location.href = appsettings.getUrl(responseData.RedirectTo);
                    }

                }
                else // if not
                {
                    // Show request result
                    showServerResponse(formId, responseData, null);

                    if (responseData.CallbackJS != null && responseData.CallbackJS != undefined) {
                        Function(responseData.CallbackJS)(); // execute callbackJS content (dont wrap more than one function call in one function as a wrapper, that will not execute)
                    }

                    // When navigate back is true (as property given 'taghelper') and request is successfull. 
                    if (navigateBack && responseData.Succesfully) {

                        if (kendoWindowId == "") {
                            if (history.length > 2) {
                                history.back(); // go back one page using the breadcrumb hist.
                            }
                        } else {
                            var kendoWindow = $(kendoWindowId).data("kendoWindow");

                            if (kendoWindow !== undefined) {
                                kendoWindow.close();
                            }
                        }

                    }
                }
            }
        });
    }
}


function onHide(callBack: (e: any) => void): any {
    if (callBack != null && callBack != undefined) {
        setTimeout(callBack as (e: any) => void, WAIT_DELAY);
    }
}


export function initialize(): void {

    // Attach onchange event handler to all Kendo inputs
    $('input.k-input').on('change', function () {

        // Your onchange code goes here
        console.log('input changed!');
    });

    // Show required tagged inputs
    $("input[input-precom-required = 'true']").parent().css("border-left", "3px solid red");
}

/**s
    * submit the data (model) and give the user feedback.
    * @param {responseModel | undefined | null} responseData
    */
export function showResult(responseData: responseModel | undefined | null): void {
    var color = 'black';

    if (responseData.Succesfully != undefined) {
        color = (responseData.Succesfully ? 'blue' : 'red');

        if (responseData.Message == undefined || responseData.Message == null) {
            responseData.Message = (responseData.Succesfully ? "Saved" : "Error");
        }

        $('#Validation').attr('style', 'color:' + color);
        $('#Validation').text(responseData.Message);
    }
}


/**
 * submit form with action. Report result back by calling showResult
 * @param {string} formId
 * @param {string} actionUrl
 * @param {boolean} navigateBack
 * @param {string} kendoWindowId
 */
export async function submitForm(formId: string, actionUrl: string, navigateBack: boolean, kendoWindowId: string): Promise<any> {

    const validator = $('#' + formId).kendoValidator().data('kendoValidator');
    let response = "";
    kendo.ui.progress($(document.body), true);

    if (validator.validate()) {

        const serializeddata = $('#' + formId).serialize();

        await $.ajax({
            type: 'post',
            dataType: 'json',
            url: appsettings.getUrl(actionUrl),
            data: serializeddata,
            success: function (responseData) {
                response = responseData;

                inputs.removeDirtyInput(); // remove dirty input

                // redirect defined
                if (responseData.RedirectTo != undefined) {
                    // succesfull callback 
                    if (responseData.Succesfully) {
                        location.href = appsettings.getUrl(responseData.RedirectTo);
                    }
                }
                else // if not
                {
                    //// Show request result
                    showServerResponse(formId, responseData, null);

                    if (responseData.CallbackJS != null && responseData.CallbackJS != undefined) {
                        Function(responseData.CallbackJS)(); // execute callbackJS content (dont wrap more than one function call in one function as a wrapper, that will not execute)
                    }

                    // When navigate back is true (as property given 'taghelper') and request is successfull. 
                    if (navigateBack && responseData.Succesfully) {

                        if (kendoWindowId == "") {
                            if (history.length > 2) {
                                history.back(); // go back one page using the breadcrumb hist.
                            }
                        } else {
                            var kendoWindow = $(kendoWindowId).data("kendoWindow");

                            if (kendoWindow !== undefined) {
                                kendoWindow.close();
                            }
                        }
                    }
                }

            }

        });

    } else {
        kendo.ui.progress($(document.body), false);
        var errors = validator.errors;                      // validator._errors;
        $(errors).each(function () {
            console.log(this);
        });
    }

    return response;
}

/**
 * Create form buttons for the form
 * Part of the TagHelper 'FormButtonsTagHelper'
 * @param {string} formId
 * @param {boolean} showResultInBrowser
 * @param {string} actionUrl
 * @param {string} redirectTo
 * @param {string} idCancel
 * @param {boolean} skipCancel
 * @param {string} idSubmit
 * @param {boolean} navigateBack
 * @param {string} kendoWindowId
 * @param {boolean} submitWithFile
 */
export function createFormButtons(formid: string, actionUrl: string, idCancel: string, skipCancel: boolean, idSubmit: string, navigateBack: boolean, kendoWindowId: string, submitWithFile: boolean) {

    // Submit button
    $(idSubmit).kendoButton({
        themeColor: "primary",
        click: function () {
            if (submitWithFile) {
                submitFormWithFile(formid, actionUrl, navigateBack, kendoWindowId);
            } else {
                submitForm(formid, actionUrl, navigateBack, kendoWindowId);
            }
        }
    });

    // Cancel button
    if (!skipCancel) {
        $(idCancel).kendoButton({
            themeColor: "secondary",
            click: function () {
                history.back();
            }
        });
    }
}

/**
 * Ticket 1579650 - kendo issue reported hidden fields not working for tagHelper 
 * @param {any} container
 * @param {any} options
 */
export function hiddenEditor(container: any, options: any): void {
    $('<input type="hidden" data-bind="value: ' + options.field + '" name="' + options.field + '"/>')
        .appendTo(container);
}

/**
 * Show required tagged inputs 
 */
//initialize: function () {
//    $("input[input-precom-required = 'true']").parent().css("border-left", "3px solid red");
//},

/**
 * Give user feedback on the server response. When a error occurs, users are notified by a messagebox / dialog, otherwise the user will be informed with a toast message. 
 * @param {any} formId
 * @param {any} responseData
 */
export function showServerResponse(formId: string, responseData: responseModel | undefined | null, callBack: (e: any) => void): void {
    formId = formId ? "#" + formId : ""; //formId can be empty
    kendo.ui.progress($(document.body), false);
    if (responseData != null && responseData != undefined) {

        if (!responseData.Succesfully && responseData.Message)  // Error (validation or anything other)
        {
            main.openActionsDialog(' ',
                responseData.Message, [{
                    text: 'Ok',
                    action: function () {
                        main.closePopup();
                    }, primary: true
                }]);
        }
        else if (responseData.Succesfully)                      // Success Message 
        {
            $("#staticNotification").kendoNotification({
                appendTo: formId + " .precom-form-feedback",
                autoHideAfter: WAIT_DELAY,
                hide: onHide(callBack)
            }).data("kendoNotification").show(" " + responseData.Message, "info");
        }
        else                                                    // Error with no info ^^
        {
            $("#staticNotification").kendoNotification({
                appendTo: formId + " .precom-form-feedback",
                autoHideAfter: WAIT_DELAY
            }).data("kendoNotification").show(" " + responseData.Message, "error");
        }
    }
}

/**
 * Create dialog
 */
export function createDialog(title: string, message: string, buttonTextYes: string, callbackYes: () => void, buttonTextNo: string, callbackNo: () => void): void {

    if ($("#dialog").length === 0) {
        $("body").append('<div id="dialog"></div>');
    }

    // Create the Kendo dialog
    $("#dialog").kendoDialog({
        width: "400px",
        title: title,
        closable: false,
        content: message,
        actions: [
            { text: buttonTextYes, primary: true, action: callbackYes },
            { text: buttonTextNo, action: callbackNo }
        ],
        close: onClose
    });

}

export function createWarningDialog(title: string, message: string): void {

    if ($("#dialog").length === 0) {
        $("body").append('<div id="dialog"></div>');
    }

    $("#dialog").kendoDialog({
        width: "400px",
        title: title,
        closable: true,
        content: message,
        actions: [
            { text: "OK", primary: true, action: closeDialog }
        ],
        close: onClose
    });
}


function onClose() {

    // dialog still exists ?
    if ($('#dialog').length == 1 && $("#dialog").data("kendoDialog") != undefined) {
        $("#dialog").data("kendoDialog").destroy();     // deletes kendo widgets from the DOM element.
        $("#dialog").remove();                          // removes the element from the DOM.
    }

    // make new dialog (anchor) point
    if ($('#dialog').length == 0) {        
        $("body").append("<div id='dialog'></div>");
    }
}

export function closeDialog(): void {

    var dialog = $("#dialog").data("kendoDialog");
    if (dialog != undefined) {
        dialog.close();
    }
}


/**
 * Submit data
 * @param {string} formId
 * @param {string} actionUrl
 * @param {string} fieldName
 * @param {any} data
 * @param {boolean} navigateBack
 * @param {boolean} reload
 * @param {string} kendoElementId
 */
export function submitData(formId: string, actionUrl: string, fieldName: string, data: any, navigateBack: boolean, reload: boolean, kendoElementId: string): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: data,
        success: function (responseData) {

            if (responseData.Succesfully) {
                $(fieldName).text("");
            }

            // Show request result
            showServerResponse(formId, responseData, null);

            if (responseData.Succesfully) {

                if (responseData.RedirectTo != undefined && responseData.RedirectTo != '') {
                    location.href = responseData.RedirectTo;
                } else if (navigateBack) {

                    // When navigate back is true (as property given 'taghelper') and request is successfull. 
                    if (kendoElementId == "") {
                        history.back();
                    } else {
                        var kendoWindow = $(kendoElementId).data("kendoWindow");

                        if (kendoWindow !== undefined) {
                            kendoWindow.close();
                        }
                    }
                } else if (reload) {
                    var elementFound = false;
                    var kendoElement = $(kendoElementId);
                    if (kendoElement !== undefined) {
                        var kendoTabStrip = kendoElement.data("kendoTabStrip");
                        if (kendoTabStrip !== undefined) {
                            elementFound = true;
                            kendoTabStrip.reload(".k-active");
                        }
                    }

                    if (!elementFound) {
                        navigation.navigateToCurrentModule();
                    }
                }
            }
        }
    });
}

/**
 * delete Data
 * @param {string} formId
 * @param {string} actionUrl
 * @param {string} fieldName
 * @param {any} data
 * @param {boolean} navigateBack
 * @param {boolean} reload
 * @param {string} kendoElementId
 */
export function deleteData(formId: string, actionUrl: string, fieldName: string, data: any, navigateBack: boolean, reload: boolean, kendoElementId: string): void {
    $.ajax({
        type: "GET",
        url: appsettings.getUrl(actionUrl),
        data: data,
        success: function (responseData) {

            if (responseData.Succesfully) {
                $(fieldName).text(""); // TODO:
            }

            // Show request result
            showServerResponse(formId, responseData, null);

            if (responseData.Succesfully) {
                if (responseData.RedirectTo != undefined && responseData.RedirectTo != '') {
                    location.href = responseData.RedirectTo;
                } else if (navigateBack) {
                    // When navigate back is true (as property given 'taghelper') and request is successfull. 
                    if (kendoElementId == "") {
                        history.back();
                    } else {
                        var kendoWindow = $(kendoElementId).data("kendoWindow");

                        if (kendoWindow !== undefined) {
                            kendoWindow.close();
                        }
                    }
                } else if (reload) {
                    var elementFound = false;
                    var kendoElement = $(kendoElementId);
                    if (kendoElement !== undefined) {
                        var kendoTabStrip = kendoElement.data("kendoTabStrip");
                        if (kendoTabStrip !== undefined) {
                            elementFound = true;
                            kendoTabStrip.reload(".k-active");
                        }
                    }

                    if (!elementFound) {
                        navigation.navigateToCurrentModule();
                    }
                }
            }
        }
    });
}

